import "./Beauty.module.css";
import Header from "@/reusable_sections/Header";
import TheArtOfTheAura from "./sections/TheArtOfTheAura";
import SignatureRituals from "./sections/SignatureRituals";
import SanctuaryMembership from "./sections/SanctuaryMembership";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function BeautyPage() {
  return <div>
      <Header />
      <TheArtOfTheAura />
      <SignatureRituals />
      <Faq />
      <SanctuaryMembership />
      <Footer />
    </div>;
}